module.exports = __webpack_public_path__ + "static/img/bg-es.848566c9.webp";